export const COMPLAINT_URL = (complaintId: string | number) => `/complaints/${complaintId}`
export const VIEW_ISSUE_DETAILS_URL = (transactionId: number) => `/issue_details/${transactionId}`
export const NEW_HELP_TICKET_URL = '/help/support_tickets/new'
export const SERVICE_FEE_HELP_URL = '/help/342'
export const SERVICE_FEE_PRO_HELP_URL = '/help/908'
export const COMPLAINT_MORE_INFORMATION_URL = (complaintId: string) =>
  `/complaints/${complaintId}/faq_entry`
